export const required = value => (value ? undefined : 'Required');



// WEBPACK FOOTER //
// ./src/forms/validators/index.js